// extracted by mini-css-extract-plugin
export default {"new":"newPage_new__wakfV","newImg":"newPage_newImg__k8+oC","newLetter":"newPage_newLetter__TDH3m"};